import { Component, OnInit, AfterViewInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FlashMessagesService } from "angular2-flash-messages";
import { cloneDeep } from "lodash";
import { Subscription } from "rxjs";
import { CclNavbarFooterService, CclMessageService } from "certain-common-library";
import { SharedService } from "../../../../../../modules/shared/services/shared.service";
import { CatalogService } from "../../../../../../modules/shared/services/catalog.service";
import { LocalDataService } from "../../../../../../modules/shared/services/local-data.service";

@Component({
    selector: "calendar-template",
    templateUrl: "./calendar-template.view.html",
    providers: []
})
export class CalendarTemplateView implements OnInit, AfterViewInit, OnDestroy {
    subscription: Subscription;
    sessionConfigObj: any = {};
    sessionConfig: any = {};
    catalogLayoutConfig: any = {};
    ddfs: Array<any>;
    ddfData: Array<any> = [];
    ddfGroups: Array<string> = [];
    baseUrl = "";
    textConfig: any = {};
    ddfJson = "session-ddf.json";

    constructor(
        public sharedService: SharedService,
        private _flashMessagesService: FlashMessagesService,
        private catalogService: CatalogService,
        private localDataService: LocalDataService,
        private navbarFooterService: CclNavbarFooterService,
        private messageService: CclMessageService,
        private activatedRoute: ActivatedRoute,
        private router: Router
    ) {
        this.subscription = this.messageService.getMessage().subscribe(message => this.saveConfig(message));
    }

    ngOnInit() {
        if (this.activatedRoute.parent.routeConfig.path == "add-setting") {
            this.loadConfigObj();
            this.catalogLayoutConfig = JSON.parse(this.sharedService.setup.layoutConfig);
            this.ddfGroups = ["Session", "Webinar", "Event", "Registration"];
            this.baseUrl = "general";

            if(this.router.url.search('add-to-calendar-config')>-1) {
                this.ddfGroups.pop();
                this.sharedService.expansionStyle = 'calendar';
            }

            if(this.router.url.search('add-to-calendar-config')>-1 &&
                !this.sessionConfig.catalogConfig[this.sharedService.expansionStyle]) {

                this.sessionConfig.catalogConfig[this.sharedService.expansionStyle] = {
                    textConfig: this.sharedService.addEventtoCalendarConfig
                };
            }

            this.textConfig = this.sessionConfig.catalogConfig[this.sharedService.expansionStyle].textConfig;

            this.localDataService.getJSON(this.ddfJson).subscribe((data) => {
                if (data != null) {
                    this.ddfData = data;
                    this.fetchDdfs();
                }
            });
        }
    }

    ngAfterViewInit(): void {
        if (this.router.url.search('add-to-calendar-config')>-1 &&
        this.navbarFooterService.navbar != null &&
        this.navbarFooterService.navbar.rightNavbarItems != null) {

            if (this.catalogLayoutConfig.listType == "magazine") {
                this.navbarFooterService.navbar.rightNavbarItems[0].label =
                    "NEXT STEP: Rules & Validations";
            } else if (this.catalogLayoutConfig.listType == "promoted") {
                this.navbarFooterService.navbar.rightNavbarItems[0].label =
                    "NEXT STEP: Define Data for promoted section";
            } else {
                this.navbarFooterService.navbar.rightNavbarItems[0].label =
                    "NEXT STEP: Define Data for general section";
            }
            this.navbarFooterService.navbar.rightNavbarItems[1].message = "save-template-config";
            this.navbarFooterService.navbar.rightNavbarItems[2].message = "save-next-template-config";
        }
        this.messageService.sendMessage("update-publish-button");
    }

    private loadConfigObj() {
        this.sessionConfigObj = this.sharedService.configs[this.sharedService.configTypes.SESSION['general']];

        if (this.sessionConfigObj == null || this.sessionConfigObj.id == null) {
            this.sessionConfig = cloneDeep(this.sharedService.sessionLayoutConfig.general);
            this.sessionConfigObj = {
                id: null,
                sessionCatalogSetup: {
                    id: this.sharedService.setup.id
                },
                config: null,
                configType: this.sharedService.configTypes.SESSION['general']
            };
        } else {
            this.sessionConfig = JSON.parse(this.sessionConfigObj.config);
        }
    }

    private saveConfig(message) {
        console.log("---------116---------");
        if (message.text == "save-template-config" || message.text == "save-next-template-config") {
            this.sessionConfigObj.config = JSON.stringify(this.sessionConfig);
            this.catalogService.saveSetupConfig(this.sessionConfigObj).subscribe((resp) => {
                // For checking unsaved data
                this.sharedService.createCss(this.catalogService);
                this.sharedService.originalData = cloneDeep(this.sessionConfig);
                this.sharedService.changedData = this.sessionConfig;

                this.sessionConfigObj = resp.body["sessionCatalogSetupConfigDTO"];
                if(this.sharedService.setup.setupConfigs && this.sharedService.setup.setupConfigs.length>0) {
                    let index = this.sharedService.setup.setupConfigs.findIndex(elem => elem.id === this.sessionConfigObj.id);
                    this.sharedService.setup.setupConfigs[index] = this.sessionConfigObj;
                }
                this.sharedService.configs[this.sharedService.configTypes.SESSION['general']] = this.sessionConfigObj;
                this._flashMessagesService.show(
                    "Add To Calendar saved successfully.",
                    {
                        cssClass: "alert-success"
                    }
                );
                this.messageService.sendMessage("update-setting");
                if (message.text == "save-next-template-config") {
                    this.sharedService.catalogNavigateHelper("admin", "catalog/add-setting/rules-validation-config");
                }
            });
        }
    }

    setHeader(ev) {
        this.textConfig.template = ev;
    }

    fetchDdfs() {
        let ddfResults = [];
        for (let i = 0; i < this.ddfData.length; i++) {
            const ddf = this.ddfData[i];
            if((ddf.label == 'Abstract File' || ddf.label == 'Presentations' || ddf.label == 'Show other schedules') && this.router.url.search('add-to-calendar-config') >- 1) {
                continue;
            }

            let groupName = ddf.type.toLowerCase();
            groupName = groupName.charAt(0).toUpperCase() + groupName.substring(1);
            const tinymceDdf = {
                group: groupName,
                title: ddf.label.trim(),
                variableKey: ddf.key.substring(2, ddf.key.length - 2),
                variableValue: ddf.label.trim()
            };
            ddfResults.push(tinymceDdf);
        }
        this.ddfs = ddfResults;
    }

    ngOnDestroy() {
        this.sharedService.unsubscribeHelper(this.subscription);
    }
}
